import anime from 'animejs'
import {
  createAnimation
} from '../utils/createAnimation'
import {
  characterWalk
} from '../utils/characterWalk'
import {
  createRotateAnimation
} from '../utils/createRotateAnimation'
import {
  createWalkAnimation
} from '../utils/createWalkAnimation'

const ayeAnimations = () => {
  return {
    enter(options) {
      return createAnimation((tl, options) => {
        options.duration = options.duration || 3500
        tl
          .add({
            targets: '#aye',
            translateY: characterWalk(options.duration, 11, 950),
            left: ['-20%', '36%'],
            easing: 'linear',
            duration: options.duration,
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    },
    exit(options) {
      return createAnimation((tl, options) => {
        options.duration = options.duration || 8000
        tl.add({
          targets: '#aye',
          left: ['20%', '100%'],
          translateY: characterWalk(options.duration),
          easing: 'linear',
          duration: options.duration,
          begin: options.begin,
          complete: options.complete
        })
      }, options, this)()
    },
    walkInPlace(options) {
      return createAnimation((tl, options) => {
        options.duration = options.duration || 8000
        options.flipped = options.flipped || false
        options.left = options.left || ['36%', '20%']
        tl
          .add({
            targets: '#aye',
            scaleX: {
              value: options.flipped ? -1 : 1,
              duration: 1
            }, // flip aye conditionally
            left: options.left, // gradually move closer to left side of scene. TODO: make options for this
            translateY: characterWalk(options.duration),
            easing: 'linear',
            duration: options.duration,
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    },
    raiseRightArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: '#aye_right_arm_hand',
            rotate: '-120deg',
            easing: 'linear',
            duration: 350,
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    },
    lowerRightArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: '#aye_right_arm_hand',
            rotate: '0deg',
            easing: 'linear',
            duration: 350,
            begin: options.begin
          })
          .add({
            targets: "#aye_right_hand",
            scaleX: 1,
            easing: "linear",
            duration: 1
          })
          .add({
            targets: '#aye_right_arm',
            rotate: '0deg',
            easing: 'linear',
            duration: 350,
            complete: options.complete
          })
      }, options, this)()
    },
    raiseLeftArm(options) {
      return createAnimation((tl, options) => {
        if (options.quarter) {
          tl
            .add({
              targets: '#aye_left_arm',
              rotate: '-15deg',
              easing: 'linear',
              duration: 350,
              begin: options.begin
            })
            .add({
              targets: '#aye_left_arm_hand',
              rotate: '-85deg',
              easing: 'linear',
              duration: 350,
              complete: options.complete
            })
        } else if (options.half) {
          tl
            .add({
              targets: '#aye_left_arm_hand',
              rotate: '-120deg',
              easing: 'linear',
              duration: 350,
              complete: options.complete
            })
        } else if (options.threeQuarters) {
          tl
            .add({
              targets: '#aye_left_arm',
              rotate: '-15deg',
              easing: 'linear',
              duration: 350,
              begin: options.begin
            })
            .add({
              targets: '#aye_left_arm_hand',
              rotate: '-120deg',
              easing: 'linear',
              duration: 350,
              complete: options.complete
            })
        } else {
          tl
            .add({
              targets: '#aye_left_arm',
              rotate: '-40deg',
              easing: 'linear',
              duration: 350,
              begin: options.begin
            })
            .add({
              targets: '#aye_left_arm_hand',
              rotate: '-90deg',
              easing: 'linear',
              duration: 350,
              complete: options.complete
            })
        }

      }, options, this)()
    },
    lowerLeftArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: '#aye_left_arm_hand',
            rotate: '0deg',
            easing: 'linear',
            duration: 350,
            begin: options.begin
          })
          .add({
            targets: '#aye_left_arm',
            rotate: '0deg',
            easing: 'linear',
            duration: 350,
            complete: options.complete
          })
      }, options, this)()
    },
    handShake(options) {

      return createAnimation((tl, options) => {
        if (options.left) {
          // todo: add left handshake
          tl
            .add({
              targets: "#aye_left_arm",
              rotate: "-15deg",
              easing: 'linear',
              duration: 350,
            })
            .add({
              targets: "#aye_left_arm_hand",
              rotate: "-76deg",
              easing: "linear",
              duration: 350
            })
        } else {
          tl
            .add({
              targets: '#aye_right_arm',
              rotate: '-50deg', // '-35deg',
              easing: 'linear',
              duration: 350,
              begin: options.begin
            })
            .add({
              targets: '#aye_right_arm_hand',
              rotate: '-40deg', // '-60deg',
              easing: 'linear',
              duration: 350,
            })

            // handshake
            .add({
              targets: '#aye_right_arm_hand',
              rotate: '-28deg', // '-48deg', // bump down by 12deg
              easing: 'linear',
              duration: 350,
            })
            .add({
              targets: '#aye_right_arm_hand',
              rotate: '-40deg', // '-60deg',
              easing: 'linear',
              duration: 350,
              complete: options.complete
            })
        }
      }, options, this)()
    },
    scratchHead(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: '#aye_left_arm',
            rotate: '-130deg',
            easing: 'linear',
            duration: 500,
            begin: options.begin
          })
          .add({
            targets: '#aye_left_arm_hand',
            rotate: '-120deg',
            easing: 'linear',
            duration: 700,
            offset: '-=100', // start forearm movement right before upper arm completes
          })

          // move forearm up/down
          .add({
            targets: '#aye_left_arm_hand',
            rotate: '-130deg',
            easing: 'linear',
            duration: 350,
          })
          .add({
            targets: '#aye_left_arm_hand',
            rotate: '-120deg',
            easing: 'linear',
            duration: 350,
          })
          .add({
            targets: '#aye_left_arm_hand',
            rotate: '-130deg',
            easing: 'linear',
            duration: 350,
          })
          .add({
            targets: '#aye_left_arm_hand',
            rotate: '-120deg',
            easing: 'linear',
            duration: 350,
            complete: options.complete
          })
      }, options, this)()
    },
    wave(options) {
      return createAnimation((tl, options) => {
        this.raiseLeftArm({
          threeQuarters: true,
          begin: options.begin,
          complete: () => { // => preserve context
            tl
              .add({
                targets: '#aye_left_arm_hand',
                rotate: '-120deg',
                easing: 'linear',
                duration: 350
              })
              .add({
                targets: '#aye_left_arm_hand',
                rotate: '-130deg',
                easing: 'linear',
                duration: 350
              })
              .add({
                targets: '#aye_left_arm_hand',
                rotate: '-120deg',
                easing: 'linear',
                duration: 350
              })
              .add({
                targets: '#aye_left_arm_hand',
                rotate: '-130deg',
                easing: 'linear',
                duration: 350
              })
              .add({
                targets: '#aye_left_arm_hand',
                rotate: '-120deg',
                easing: 'linear',
                duration: 350,
                complete: options.complete
              })
          }
        })
      }, options, this)()
    },
    deskHands(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#aye_left_arm, #aye_right_arm",
            rotate: "15deg",
            duration: 350,
            easing: "linear",
            begin: options.begin
          })
          .add({
            targets: "#aye_left_arm_hand, #aye_right_arm_hand",
            rotate: "-105deg",
            easing: 'linear',
            duration: 350,
            complete: options.complete
          })
      }, options, this)()
    },
    openArms(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#aye_left_arm",
            rotate: "-10deg",
            easing: 'linear',
            duration: 350,
            begin: options.begin
          })
          .add({
            targets: "#aye_left_arm_hand",
            rotate: "-120deg",
            easing: 'linear',
            duration: 350
          })
          .add({
            targets: "#aye_right_arm",
            rotate: "10deg",
            easing: 'linear',
            duration: 350,
            offset: "-=700"
          })
          .add({
            targets: "#aye_right_hand",
            scaleX: -1,
            easing: "linear",
            duration: 1,
            offset: "-=350"
          })
          .add({
            targets: "#aye_right_arm_hand",
            rotate: "120deg",
            easing: 'linear',
            duration: 350,
            offset: "-=350",
            complete: options.complete
          })
      }, options, this)()
    },
    rotate(options) {
      return createAnimation(createRotateAnimation('#aye'), options, this)()
    },
    headRotate(options) {
      // rotated: true rotates head, rotated: false resets head
      return createAnimation((tl, options) => {
        options.flipped = options.flipped || false
        tl
          .add({
            targets: "#aye_head",
            scaleX: {
              value: options.flipped ? -1 : 1,
              duration: 1,
              begin: options.begin,
              complete: options.complete
            },
          })
      }, options, this)()
    }
  }
}

export {
  ayeAnimations
}



// WEBPACK FOOTER //
// ./src/assets/js/characters/ayeAnimations.js